/**
 * Utility functions shared across the application.
 */

// Helper function to convert Gregorian date to Coptic calendar
export const toCopticDate = (gregorianDate) => {
  const date = new Date(gregorianDate);
  const copticMonths = [
    'توت', 'بابه', 'هاتور', 'كيهك', 'طوبه', 'أمشير',
    'برمهات', 'برموده', 'بشنس', 'بؤونه', 'أبيب', 'مسرى', 'نسيء'
  ];
  const gYear = date.getFullYear();
  const gMonth = date.getMonth() + 1;
  const gDay = date.getDate();
  const copticNewYearDay = 11;
  let copticYear, copticMonth, copticDay;
  if (gMonth > 9 || (gMonth === 9 && gDay >= copticNewYearDay)) {
    copticYear = gYear - 283;
    const newYearDate = new Date(gYear, 8, copticNewYearDay);
    const daysDiff = Math.floor((date - newYearDate) / (1000 * 60 * 60 * 24));
    copticMonth = Math.floor(daysDiff / 30);
    copticDay = (daysDiff % 30) + 1;
  } else {
    copticYear = gYear - 284;
    const lastNewYearDate = new Date(gYear - 1, 8, copticNewYearDay);
    const daysDiff = Math.floor((date - lastNewYearDate) / (1000 * 60 * 60 * 24));
    copticMonth = Math.floor(daysDiff / 30);
    copticDay = (daysDiff % 30) + 1;
  }
  if (copticMonth > 12) { copticMonth = 12; copticDay = Math.min(copticDay, 6); }
  if (copticMonth < 0) copticMonth = 0;
  if (copticDay < 1) copticDay = 1;
  if (copticMonth < 12 && copticDay > 30) copticDay = 30;
  if (copticMonth === 12 && copticDay > 6) copticDay = 6;
  return { year: copticYear, month: copticMonths[copticMonth] || 'توت', day: copticDay };
};

// Helper function to format date without timezone issues
export const formatDateForAPI = (date) => {
  if (!date) return null;
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return null;
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error formatting date:', error, date);
    return null;
  }
};

// Helper function to format date for display (day.month.year) with English numbers
export const formatDateForDisplay = (date) => {
  if (!date) return '';
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const formatString = `${day}.${month}.${year}`;
    return formatString.replace(/[٠-٩]/g, (d) => {
      return '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString();
    });
  } catch (error) {
    console.error('Error formatting date for display:', error, date);
    return '';
  }
};
